const isNewPage = ({ query = "", catId = null, searchTerm = "", page }) => {
  const searchParams = new URLSearchParams(query);
  const q = searchParams.get("q") || "";
  const cid = parseInt(searchParams.get("cid")) || null;

  return page.isNewPage || cid !== catId || q !== searchTerm;
};

export default isNewPage;
